"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Provide;
function Provide(name, provider) {
  return function (context) {
    context[name] = provider;

    if (context.debugger) {
      context.debugger.wrapProvider(name);
    }

    return context;
  };
}
//# sourceMappingURL=Provide.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/cerebral/lib/Provide.js
// module id = 706
// module chunks = 0